// if a price is not a whole number, display the price to 2 decimal places (ex: 89.50)
// else display the price as a whole number (ex: 59)
export const displayShopV3PricingFormat = (symbolCurrency: string, price: number | undefined) => {
  if (price) {
    const formattedPrice = price % 1 !== 0 ? price.toFixed(2) : price;
    return `${symbolCurrency}${formattedPrice}`;
  }

  return null;
};
